import { render, staticRenderFns } from "./slanted-arrow.vue?vue&type=template&id=354c2409&"
import script from "./slanted-arrow.vue?vue&type=script&lang=js&"
export * from "./slanted-arrow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports